class NumCountUp {
  constructor(el) {
    this.el = el;
    // 要素を取得して監視を開始する
    const items = document.querySelectorAll("." + this.el);
    this.initObserver(items);
  }

  initObserver(items) {
    const options = {
      threshold: 1  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observer = new IntersectionObserver((entries) => {
      this.shuffleNumberCounter(entries);
    }, options);

    items.forEach(target => {
      observer.observe(target);
    });
  }

  shuffleNumberCounter(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('is-visible')) {
        const counterEle = entry.target;
        const from = parseFloat(entry.target.dataset.from || 0);
        const to = parseFloat(entry.target.dataset.to || 0);
        const duration = parseInt(entry.target.dataset.duration) || 1500;

        if (!Number.isFinite(from) || !Number.isFinite(to) || from > to) {
          return false;
        }

        const increment = to - from;
        const decimalPointLength = getDecimalPointLength(increment);
        const startTime = performance.now();

        const countUp = (timestamp) => {
          const elapsed = performance.now() - startTime;
          const countValue = (from + ((elapsed / duration) * increment)).toFixed(decimalPointLength);

          if (countValue >= to) {
            counterEle.innerText = to;
          } else {
            counterEle.innerText = parseFloat(countValue);
            requestAnimationFrame(countUp);
          }
        };

        requestAnimationFrame(countUp);
        entry.target.classList.add('is-visible');
      }
    });
  }

  event() {
    console.log('イベント');
  }
}

function getDecimalPointLength(number) {
  const str = number.toString();
  const index = str.indexOf('.');
  return index === -1 ? 0 : str.length - index - 1;
}
